export { IrManagePage as default } from '@/components/enpages/Ir/Manage'
